import React, { Component } from "react";
import styled, { css } from "styled-components";

import { Icon } from "../../../../Components/Icon";
import { IconButton } from "../../../../Components/IconButton";
import { ToolTip } from "../../../../Components/ToolTip";
import { t } from "../../../../i18n";
import Spinner from "../../../../react/components/Spinner";

const mutedUsedStateStyles = css`
    opacity: 0.5;
`;

const processingStyles = css`
    opacity: 0.7;
`;

const FileEntryContainer = styled.div`
    position: relative;
    display: flex;
    gap: 5px;
    color: ${props => props.color};
    background: ${props => props.background};
    font-size: 14px;
    border: solid 1px ${props => props.borderColor ?? "#888"};
    padding: 2px 5px;
    border-radius: 10px;
    align-items: center;
    user-select: none;
    font-weight: 400;
    opacity: ${props => props.opacity ?? 1};

    ${props => props.$isProcessing && processingStyles}
    ${props => props.$mutedUsedState && mutedUsedStateStyles}
`;

const FileEntryButton = styled(IconButton)`
    height: 16px;
    width: 16px;
    min-width: 16px;
    border-radius: 50%;

    &:hover {
        background: rgba(0, 0, 0, 0.2);
    }
`;

class FileEntry extends Component {
    render() {
        let { file, disabled, color = "#333", background = "transparent", hideButton = false, onRemove, usedTooltip, mutedUsedState = false } = this.props;

        let Content = (
            <FileEntryContainer
                color={color}
                background={background}
                $mutedUsedState={mutedUsedState || file.hasBeenUsed}
                $isProcessing={file.isProcessing}
            >
                {file.isProcessing &&
                    <div style={{ position: "relative", width: 25, height: 20, transform: "scale(0.8)", marginRight: -5 }}>
                        <Spinner small />
                    </div>
                }
                {file.hasBeenUsed && (
                    <Icon>check_circle</Icon>
                )}
                {!file.isProcessing && !file.hasBeenUsed && (
                    <Icon>upload_file</Icon>
                )}
                {file.name}
                {!file.isProcessing && !file.hasBeenUsed && !hideButton && (
                    <FileEntryButton icon="close" size={16} onClick={() => onRemove(file)} disabled={disabled} />
                )}
            </FileEntryContainer>
        );

        if (file.hasBeenUsed) {
            let usedForDescription = "";
            if (file.hasBeenUsedFor === "outline") {
                usedForDescription = t("This file was used previously to generate the outline and isn't included now. Add it again to use it for generation.");
            } else if (file.hasBeenUsedFor === "edit") {
                usedForDescription = t("This file was used previously to update the outline and isn't included now. Add it again to use it for generation.");
            } else if (file.hasBeenUsedFor === "slide") {
                usedForDescription = t("This file was used previously to generate the slide ideas and isn't included now. Add it again to use it for generation.");
            }

            const tooltipTitle = usedTooltip || usedForDescription;

            return (
                <ToolTip title={tooltipTitle}>
                    {Content}
                </ToolTip>
            );
        }

        return Content;
    }
}

export default FileEntry;
